// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__37_EF","footer":"ReportModalFilter_footer__30H9h"};